angular.module("vgresiduos").component("customReportCreateConfigurations", {
	controller: "CustomReportCreateConfigurationsCtrl",
	templateUrl: "views/customReports/customReportCreate/stages/customReportCreateConfigurations_template.html",
	bindings: {
		model: "="
	}
});
